<template>
  <div class="viz-filter--mobile">
    <div class="filter-button" @click="showFilters = !showFilters">
      <svgicon
        class="icon-filter-mobile"
        icon="icon-filter-mobile"
        width="14"
        height="14"
      ></svgicon>
    </div>
    <div
      class="viz-filter--mobile__shadow"
      v-if="showFilters"
      @click="showFilters = !showFilters"
    ></div>
    <div class="viz-filter--mobile__container" :class="{ open: showFilters }">
      <div class="viz-filter--mobile__label">
        {{ content.filter.dimensions }}
      </div>
      <div
        v-for="el in config.dimensions"
        :key="el"
        class="viz-filter--mobile__option"
        @click="handleFilters(el)"
        :class="{ selected: el === getFilterViz }"
      >
        {{ content.filter.options[el] }}
        <div
          class="viz-filter--mobile__option__check"
          v-if="el === getFilterViz"
        >
          <svgicon
            class="icon-check"
            icon="icon-check"
            width="8"
            height="8"
            color="#000000"
          ></svgicon>
        </div>
      </div>
      <!--  <div
        class="viz-filter--mobile__apply"
        @click="showFilters = !showFilters"
      >
        Apply
      </div> -->
    </div>
  </div>
</template>
<script>
import config from "@/assets/content/config.json";
import { mapActions, mapGetters } from "vuex";
import genericQueryMethods from "@/mixins/genericQueryMethods";
import "../../compiled-icons/icon-check";
import "../../compiled-icons/icon-filter-mobile";

export default {
  mixins: [genericQueryMethods],
  data() {
    return {
      config: config.viz.filter,
      showFilters: false
    };
  },
  computed: {
    content() {
      return this.$ml.get("dataviz");
    },
    ...mapGetters(["getFilterViz", "getNormalizeViz"])
  },
  methods: {
    manageClick(el, elIndex) {
      // reset query
      // this.resetQuery();
      if (this.getNormalizeViz && elIndex === this.getNormalizeViz.index) {
        this.setNormalizeViz(null);
      } else {
        this.setNormalizeViz({ value: el, index: elIndex });
      }
    },
    handleFilters(el) {
      this.showFilters = !this.showFilters;
      this.setFilterViz(el);
    },
    ...mapActions(["setFilterViz", "setNormalizeViz"])
  }
};
</script>
<style lang="scss" scoped>
.viz-filter--mobile {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: $z-c;
  user-select: none;
  .filter-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: solid 1px $white;
    background-color: $black-10;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon-filter {
      fill: white;
    }
    .icon-filter-mobile {
      fill: $white;
    }
  }
  &__shadow {
    height: calc(100vh - 35px);
    width: 100vw;
    background-color: $black_50;
    position: fixed;
    top: 35px;
    left: 0;
  }
  &__container {
    position: absolute;
    width: 100vw;
    bottom: -250px;
    right: -20px;
    border: 1px solid white;
    transition: all 0.6s ease-in-out;
    &.open {
      bottom: -20px;
    }
  }
  &__label {
    color: $white;
    @include overlayM;
    text-transform: uppercase;
    background-color: $black;
    height: 50px;
    padding: 0 22px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid white;
  }
  &__option {
    color: $white;
    @include pS;
    background-color: $black;
    height: 50px;
    padding: 0 22px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid white;
    justify-content: space-between;
    &__check {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $white;
      flex-shrink: 0;
    }
  }
  &__apply {
    color: $black-80;
    @include ButtonM;
    background-color: $white;
    height: 50px;
    padding: 0 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid white;
  }
}
</style>
